import React from "react";
import ProfilesAndSettings from "views/Config/Profiles/Common";
import { composedAPI } from "./api";
import subscriberIdComposition from "./composition";
import help from "help/viewSubscriberIDProfileConfig.md";
import settingsHelp from "help/viewSubscriberIDProfileConfigSettings.md";

const ConfigSubscriberIdProfiles = ({ ...settings }) => (
  <ProfilesAndSettings
    {...subscriberIdComposition}
    {...composedAPI}
    {...settings}
    help={help}
    settingsHelp={settingsHelp}
  />
);

export default ConfigSubscriberIdProfiles;
